<app-data-table title="Users"
                [columns]="columns"
                [fetchDataFn]="loadData"
                [exportDataFn]="exportData"
                [reloadEmitter]="reloadTable$"
                [createBtnLabel]="authService.hasPermission('auth.users.create') ? 'Create User' : undefined"
                [enableGlobalSearch]="true"
                [globalFilterFields]="['name', 'email']"
                globalSearchPlaceholder="Search by name, email"
                defaultSortField="name"
                [exportable]="authService.hasPermission('auth.users.export')"
                (onCreate)="openCreateModal()">
</app-data-table>

<p-confirmDialog></p-confirmDialog>
